import { render } from "./Enrollment.vue?vue&type=template&id=10c1aa1e"
import script from "./Enrollment.vue?vue&type=script&lang=js"
export * from "./Enrollment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../var/www/html/fms_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__